/* Dutch Local Food — productpagina */
(function () {
  var LANG = ((document.documentElement.getAttribute('lang') || 'nl').slice(0, 2)).toLowerCase();
  var LABELS = {
    nl: { add: 'In winkelmandje', soldOut: 'Uitverkocht' },
    en: { add: 'Add to cart', soldOut: 'Sold out' },
    de: { add: 'In den Warenkorb', soldOut: 'Ausverkauft' }
  }[LANG] || { add: 'In winkelmandje', soldOut: 'Uitverkocht' };

  function money(cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init(root) {
    if (root.dataset.dlfpReady) return;
    root.dataset.dlfpReady = '1';

    /* ---------- Galerij ---------- */
    var mainImg = root.querySelector('[data-dlfp-main-image]');
    root.querySelectorAll('[data-dlfp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = thumb.dataset.srcset;
        mainImg.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-dlfp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---------- Aantal + staffel ---------- */
    var qtyInput = root.querySelector('[data-dlfp-qty-input]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-dlfp-tier]'));
    var tiersWrap = root.querySelector('[data-dlfp-tiers]');

    function syncTiers(qty) {
      if (!tiers.length) return;
      var match = tiers[0];
      tiers.forEach(function (t) { if (qty >= parseInt(t.dataset.dlfpTier, 10)) match = t; });
      tiers.forEach(function (t) {
        var on = t === match;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setQty(q) {
      if (!qtyInput) return;
      q = Math.max(1, parseInt(q, 10) || 1);
      qtyInput.value = q;
      syncTiers(q);
    }

    root.querySelectorAll('[data-dlfp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.dlfpQty, 10));
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { setQty(t.dataset.dlfpTier); });
    });

    function repriceTiers(cents) {
      if (!tiersWrap) return;
      tiersWrap.dataset.priceCents = cents;
      tiers.forEach(function (t) {
        var pct = parseInt(t.dataset.pct, 10) || 0;
        var el = t.querySelector('[data-dlfp-tier-price]');
        if (el) el.textContent = money(Math.floor(cents * (100 - pct) / 100));
      });
    }

    /* ---------- Variant ---------- */
    var select = root.querySelector('[data-dlfp-variant-select]');
    var idInput = root.querySelector('[data-dlfp-variant-id]');
    var priceEl = root.querySelector('[data-dlfp-price]');
    var stickyPrice = root.querySelector('[data-dlfp-sticky-price]');
    var atc = root.querySelector('[data-dlfp-atc]');
    var stickyBtn = root.querySelector('.dlfp-sticky__btn');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        idInput.value = opt.value;
        if (priceEl) priceEl.textContent = opt.dataset.price;
        if (stickyPrice) stickyPrice.textContent = opt.dataset.price;
        repriceTiers(parseInt(opt.dataset.priceCents, 10));
        var available = opt.dataset.available === 'true';
        [atc, stickyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !available;
          b.textContent = available ? LABELS.add : LABELS.soldOut;
        });
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* ---------- Sticky balk (mobiel) ---------- */
    var sticky = root.querySelector('[data-dlfp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = past ? 0 : -1;
      });
      io.observe(atc);
    }

    /* ---------- Bewaren (hartje) ---------- */
    var KEY = 'dlfc-saved';
    var saved = [];
    try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (err) {}
    root.querySelectorAll('[data-dlfp-save]').forEach(function (btn) {
      var handle = btn.dataset.dlfpSave;
      function render() {
        var on = saved.indexOf(handle) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.firstElementChild.textContent = on ? '♥' : '♡';
      }
      btn.addEventListener('click', function () {
        var i = saved.indexOf(handle);
        if (i > -1) saved.splice(i, 1); else saved.push(handle);
        try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (err) {}
        render();
      });
      render();
    });
  }

  function boot() { document.querySelectorAll('[data-dlfp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();